import { useState } from 'react';
import { useSubscriptionActive } from '@/contexts/WorkspaceContext';
import SubscribeDialog from '@/components/SubscribeDialog';

// Button-level subscription gating (a second safety layer beneath SubscriptionGate +
// the backend's requireActiveSubscription). Wrap an action handler with `guard(...)`:
// if the workspace is subscribed it runs; otherwise it pops the "subscribe first" nudge.
// Render the returned `nudge` element once in the page.
export function useSubscriptionGuard(message?: string) {
  const active = useSubscriptionActive();
  const [open, setOpen] = useState(false);

  function guard<A extends unknown[]>(fn: (...args: A) => void) {
    return (...args: A) => {
      if (active) {
        fn(...args);
        return;
      }
      setOpen(true);
    };
  }

  const nudge = active ? null : (
    <SubscribeDialog open={open} onOpenChange={setOpen} message={message} />
  );

  return { active, guard, nudge };
}
